import { useAppConfiguration, useGraphqlQuery } from '@mews-commander/data-access';
import { graphql, MatchedGuestProfiles, MatchedGuestProfilesByIdResultQuery } from '@mews-commander/guest-profile';
import { transformGuestProfiles } from './transformGuestProfiles';

const MatchedGuestProfilesByIdQueryDocument = graphql(`
    query matchedGuestProfilesByIdResult($guestIds: [UUID!]!) {
        matchedGuestProfilesById(guestIds: $guestIds) {
            id
            confidence
            matchedFields
            mergeInfo {
                isMergePossible
                errorMessage
            }
            profiles {
                ...GuestProfileFields
            }
            preSelectedFields {
                field
                profileId
            }
        }
    }
`);

const transformToMatchedGuestProfiles = (data: MatchedGuestProfilesByIdResultQuery): MatchedGuestProfiles => {
    const {
        matchedGuestProfilesById: { profiles, ...otherProps },
    } = data;

    return {
        profiles: transformGuestProfiles(profiles),
        ...otherProps,
    };
};

export const useMatchedGuestProfilesById = (guestIds: Array<string>, enabled: boolean) => {
    const { guestProfileApiUrl } = useAppConfiguration();
    const { data, ...props } = useGraphqlQuery(
        guestProfileApiUrl,
        {
            document: MatchedGuestProfilesByIdQueryDocument,
            variables: { guestIds },
        },
        {
            enabled: !!guestIds.length && enabled,
            staleTime: 0,
        }
    );

    return {
        ...props,
        data: data ? transformToMatchedGuestProfiles(data) : undefined,
    };
};
